/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import MPHInput from "src/components/DataProviders/MPHInput";
import modalClose from "../../../assets/images/modalClose.png";
import MPHButton from "../MPHButtons/MPHButton";
import { useApiAxiosRequests } from "src/utils/ApiService/MPHApis";
import {
  mobileChangeValidation,
  mobileChangeSchema,
} from "src/utils/MPHFormsSchemaValidations/MPHFormsSchemaValidations";
import { useFormik } from "formik";
import { useStorage } from "src/utils/storage";
import { errorToast, successToast } from "src/utils/toast";

const MPHMobileChange = ({ mobile, changed }: any) => {
  const [initialValues] = useState(mobileChangeSchema);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const storage = useStorage();
  const { changeMobile } = useApiAxiosRequests();

  const submitFormData = async () => {
    const payload = {
      root: {
        customer: [
          {
            identifier: "mobile",
            old_value: mobile,
            new_value: values.new_value,
          },
        ],
      },
    };
    setIsLoading(true);
    const changeResponse: any = await changeMobile(payload, email);
    setIsLoading(false);
    if (
      changeResponse.data &&
      changeResponse.data.status &&
      changeResponse.data.status.success !== "true"
    ) {
      errorToast(
        mobile === values.new_value
          ? "New number cannot be same as previous number"
          : changeResponse.data?.status?.message ===
            "All requests have failed due to errors"
          ? "Unable to update, phone number already in use"
          : changeResponse.data?.status?.message
      );
      setIsLoading(false);
      return;
    }
    successToast("Phone Number Updated Successfully");
    handleChangeSuccess();
  };

  const handleChangeSuccess = async () => {
    const modal = document.getElementById("forMobile");
    const bm = document.getElementsByClassName("modal-backdrop");
    const mp = document.getElementsByClassName("modal-open");
    if (modal && modal.classList && modal.classList.contains("show")) {
      modal.classList.remove("show");
      modal.style.display = "none";
    }
    if (bm && bm[0] && bm[0].classList.contains("show")) {
      bm[0].classList.remove("show");
      bm[0].classList.remove("modal-backdrop");
    }
    if (mp && mp[0] && mp[0].classList.contains("modal-open")) {
      mp[0].classList.remove("modal-open");
    }
    changed(values.new_value);
    setFieldValue('new_value', '');
  };

  useEffect(() => {
    const store: any = storage.get("user_profile");
    if (store && JSON.parse(store) && JSON.parse(store).email) {
      setEmail(JSON.parse(store).email);
    }
  }, []);

  const formik = useFormik({
    initialValues,
    validationSchema: mobileChangeValidation,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: submitFormData,
  });

  const { values, handleChange, setFieldValue, handleBlur, errors, touched, isValid } = formik;

  return (
    <>
      <div
        className="modal fade"
        id="forMobile"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="forMobileLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content form-modal">
            <div className="row">
              <section className="mb-3">
                <h2 className="form-header">Update Phone Number</h2>
                <img
                  className="close-modal"
                  src={modalClose}
                  alt=""
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </section>
              <div className="col-12 mt-3">
                <label htmlFor="" className="form-label">
                  OLD Number
                </label>
                <MPHInput
                  placeholder=""
                  keyboardType="number"
                  value={mobile}
                  disabled={true}
                  isModal={true}
                />
              </div>
              <div className="col-12 mt-3">
                <label htmlFor="" className="form-label">
                  NEW Number
                </label>
                <MPHInput
                  placeholder=""
                  keyboardType="number"
                  value={values.new_value}
                  isModal={true}
                  onBlur={handleBlur("new_value")}
                  onChangeText={(text: any) => {
                    handleChange("new_value")(text);
                  }}
                  isError={touched.new_value! && !!errors.new_value}
                  error={errors.new_value}
                />
              </div>
              <div className="col-12 mt-4">
                <MPHButton
                  disabled={!isValid || isLoading}
                  isLoading={isLoading}
                  buttonText="Submit"
                  onbuttonClick={() => submitFormData()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MPHMobileChange;
